// extracted by mini-css-extract-plugin
module.exports = {"input":"ProviderSearchPaneDecoration__input__6k9ai","inputWrapper":"ProviderSearchPaneDecoration__inputWrapper__CXR3w","icon":"ProviderSearchPaneDecoration__icon__hKKFa"};